<template>
    <div class="post-proofreading-instructions">
        <div class="instruction-step">
            <div class="step-title">{{ $t('proofreadingInstructions.postProofreadingUnlockTitle') }}</div>
            <p class="step-intro">{{ $t('proofreadingInstructions.postProofreadingUnlockIntro') }}</p>
            <ol>
                <li>{{ $t('proofreadingInstructions.postProofreadingUnlockStep1') }}</li>
                <li>{{ $t('proofreadingInstructions.postProofreadingUnlockStep2') }}</li>
                <li>{{ $t('proofreadingInstructions.postProofreadingUnlockStep3') }}</li>
            </ol>
        </div>

        <div class="instruction-step">
            <div class="step-title">{{ $t('proofreadingInstructions.postProofreadingChangesTitle') }}</div>
            <p class="step-intro">{{ $t('proofreadingInstructions.postProofreadingChangesIntro') }}</p>
            <ol>
                <li>{{ $t('proofreadingInstructions.postProofreadingChangesStep1') }}</li>
                <li>{{ $t('proofreadingInstructions.postProofreadingChangesStep2') }}</li>
                <li>{{ $t('proofreadingInstructions.postProofreadingChangesStep3') }}</li>
            </ol>
        </div>

        <div class="warning-box">
            <span class="warning-label">{{ $t('proofreadingInstructions.postProofreadingWarningTitle') }}</span>
            {{ $t('proofreadingInstructions.postProofreadingWarningText') }}
        </div>

        <div class="instruction-step">
            <div class="step-title">{{ $t('proofreadingInstructions.postProofreadingCommentsTitle') }}</div>
            <p class="step-intro">{{ $t('proofreadingInstructions.postProofreadingCommentsIntro') }}</p>
            <ol>
                <li>{{ $t('proofreadingInstructions.postProofreadingCommentsStep1') }}</li>
            </ol>
        </div>

        <div class="instruction-step">
            <div class="step-title">{{ $t('proofreadingInstructions.postProofreadingUploadTitle') }}</div>
            <p class="step-intro">{{ $t('proofreadingInstructions.postProofreadingUploadText') }}</p>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({});
</script>

<style lang="scss" scoped>
    .post-proofreading-instructions {
        display: flex;
        flex-direction: column;
        gap: 16px;
        font-size: 14px;
        margin-top: 12px;
        text-align: left;
    }

    .instruction-step {
        .step-title {
            font-weight: bold;
            margin-bottom: 6px;
        }

        .step-intro {
            margin: 0 0 6px 0;
        }

        ol {
            margin: 0;
            padding-left: 20px;

            li {
                margin-bottom: 4px;
            }
        }
    }

    .warning-box {
        background-color: #fff3cd;
        border: 1px solid #ffc107;
        border-radius: 4px;
        padding: 10px 14px;

        .warning-label {
            font-weight: bold;
        }
    }
</style>
